exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".media-component .media{padding:20px 35px 10px;border-bottom:1px solid #f5f5f5}.media-component .media .LazyLoad,.media-component .media .wapper{background:#f5f5f5;height:calc(100vw - 70px)}.media-component .media .LazyLoad{opacity:0;transition:all .5s ease-in-out}.media-component .media .LazyLoad.is-visible{opacity:1}@media only screen and (min-width:600px){.media-component .media .LazyLoad,.media-component .media .wapper{height:528px}}.media-component .media img{width:100%;height:auto;min-height:100px}.media-component .media blockquote{color:#333;font-size:14px;border-left:none;margin-bottom:0;padding:15px 10px 10px}.media-component .media blockquote .media-desc{max-height:48px;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2}.media-component .media blockquote cite{font-size:12px;color:#999;text-align:right;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/MediaList.scss
// module id = 652
// module chunks = 0